<template>
	<div class="page">
		<div class="nucleustit">
			<div class="tit">核心数据</div>
			<div>
				<el-button type="button" style="margin-left: 10px;" @click="downloadStaffPaiMing" size="small">员工当日业绩排名</el-button>
				<el-select :disabled="!$buttonAuthority('shuju-mendianshuju-shop')" style="width: 150px;" v-model="params.shopId" placeholder="请选择" size='mini' @change="changeShop">
					<el-option v-for="item in shopList" :key='item.shop_id' :label="item.shop_name" :value="item.shop_id">
					</el-option>
				</el-select>
				<el-date-picker style="width: 130px;margin-left: 10px;" size="mini" v-model="currDate" type="date" value-format="timestamp" :picker-options="{disabledDate(date) {return date.getTime() > Date.now()}}" placeholder="选择日期" @change="changePicker" :clearable="false">
				</el-date-picker>
				<el-select size="mini" v-model="params.dateType" placeholder="请选择" style="width: 100px;margin-left: 10px;" @change="changeDateType">
					<el-option label="查看当日" value="date"></el-option>
					<el-option label="查看当周" value="week"></el-option>
					<el-option label="查看当月" value="month"></el-option>
				</el-select>
			</div>
		</div>
		<div class="panel1">
			<div class="panel1Item">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.bank_RunningAmount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">银行流水</div>
			</div>
			<div class="panel1Item">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.shop_RunningAmount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">门店流水</div>
			</div>
			<div class="panel1Item">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.rechargeAmount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">充值金额</div>
			</div>
			<div class="panel1Item">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.singleCustomer_Amount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">
					客单价
					<el-tooltip v-if="state1" effect="dark" placement="top-start">
						<div slot="content" style="line-height: 20px;">
							总金额：{{datas.singleCustomer_TotalAmount}}<br>
							进店人数：{{datas.singleCustomer_OrderCount}}<br>
						</div>
						<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
					</el-tooltip>
				</div>
			</div>
			<div class="panel1Item">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.shopUse_Amount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">自用金额</div>
			</div>
			<div class="panel1Item" style="border-right: 0;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.noUseDepositAmount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">
					未使用活体订金
					<el-tooltip v-if="state1" effect="dark" placement="top-start">
						<div slot="content" style="line-height: 20px;">
							金额：{{datas.noUseDepositAmount}}<br>
							数量：{{datas.noUseDepositCount}}<br>
						</div>
						<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
					</el-tooltip>
				</div>
			</div>
			<!-- <div class="panel1Item" style="border-right: 0;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.servicesTimes" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">服务人次</div>
			</div> -->
			<div class="panel1Item" style="border-top:1px solid #ededed;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.memberAssets" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">
					会员资产
					<el-tooltip v-if="state1" effect="dark" placement="top-start">
						<div slot="content" style="line-height: 20px;">
							余额：{{datas.memberAssets_Yue}}<br>
							洗美卡：{{datas.memberAssets_WashingCard}}<br>
							疫苗：{{datas.memberAssets_Vaccines}}<br>
							驱虫：{{datas.memberAssets_Deworming}}<br>
							定金：{{datas.memberAssets_Deposit}}<br>
							余额人数：{{datas.memberAssets_YuePersonCount}}<br>
							礼品卡：{{datas.memberAssets_GiftCard}}<br>
						</div>
						<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
					</el-tooltip>
				</div>
			</div>
			<div class="panel1Item" style="border-top:1px solid #ededed;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.memberWiped" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">
					资产核销
					<el-tooltip v-if="state1" effect="dark" placement="top-start">
						<div slot="content" style="line-height: 20px;">
							余额：{{datas.memberWiped_Yue}}<br>
							洗美卡：{{datas.memberWiped_WashingCard}}<br>
							疫苗：{{datas.memberWiped_Vaccines}}<br>
							驱虫：{{datas.memberWiped_Deworming}}<br>
							定金：{{datas.memberWiped_Deposit}}<br>
							余额使用人数：{{datas.memberWiped_YuePersonCount}}<br>
							礼品卡：{{datas.memberWiped_GiftCard}}<br>
						</div>
						<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
					</el-tooltip>
				</div>
			</div>
			<div class="panel1Item" style="border-top:1px solid #ededed;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.currentOrderCount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">订单数</div>
			</div>
			<div class="panel1Item" style="border-top:1px solid #ededed;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.returnOrderCount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">退换货单数</div>
			</div>
			<div class="panel1Item" style="border-top:1px solid #ededed;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.currentEnterShopMemberCount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">
					进店会员数
					<el-tooltip v-if="state1" effect="dark" placement="top-start">
						<div slot="content" style="line-height: 20px;">
							散客：{{datas.currentEnterGuestCount}}<br>
							参与消费会员：{{datas.currentEnterShopConsumeMemberCount}}<br>
							充值会员：{{datas.currentEnterShopRechargeMemberCount}}<br>
						</div>
						<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
					</el-tooltip>
				</div>
			</div>
			<div class="panel1Item" style="border-top:1px solid #ededed;border-right: 0;">
				<div class="num1">
					<span v-if="!state1">0</span>
					<animate-number v-else from="0" :to="datas.currentNewMemberCount" :formatter="(num)=>{return num.toFixed(2)}"></animate-number>
				</div>
				<div class="text1">新增会员数</div>
			</div>
		</div>
		<div class="panel2">
			<div class="panel2Tit">门店日志</div>
			<div >
				<div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
					<div class="panel2Item">
						<img class="panel2ItemL" src="../../assets/img/shuju/saoma.png"/>
						<div class="panel2ItemR">
							<div class="num2">
								<span v-if="!state1">0</span>
								<span v-else>{{datas.shopLog.dayPosAmount.toFixed(2)}}</span>
							</div>
							<div class="text2">二维码/银联/pos</div>
						</div>
					</div>
					<div class="panel2Item">
						<img class="panel2ItemL" src="../../assets/img/shuju/meituan.png"/>
						<div class="panel2ItemR">
							<div class="num2">
								<span v-if="!state1">0</span>
								<span v-else>{{datas.shopLog.dayMeiTuanAmount.toFixed(2)}}</span>
							</div>
							<div class="text2">电商平台</div>
						</div>
					</div>
				</div>
				<div style="display: flex;flex-wrap: wrap;justify-content: space-between;"> 
					<div class="panel2Item">
						<img class="panel2ItemL" src="../../assets/img/shuju/xianjin.png"/>
						<div class="panel2ItemR">
							<div class="num2">
								<span v-if="!state1">0</span>
								<span v-else>{{datas.shopLog.dayCashAmount.toFixed(2)}}</span>
							</div>
							<div class="text2">现金</div>
						</div>
					</div>
					<div class="panel2Item">
						<img class="panel2ItemL" src="../../assets/img/shuju/yue.png"/>
						<div class="panel2ItemR">
							<div class="num2">
								<span v-if="!state1">0</span>
								<span v-else>{{datas.shopLog.totalAmount.toFixed(2)}}</span>
							</div>
							<div class="text2">总计</div>
						</div>
					</div>
				</div>
			</div>
			<div class="panel2Table">
				<div class="panel2TableTit">
					<div class="panel2TableTitItem">项目</div>
					<div class="panel2TableTitItem">当日</div>
					<div class="panel2TableTitItem">当月</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">会员储值消费</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayMemberYUEWipedAmount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthMemberYUEWipedAmount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">会员充值</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayMemberYUERechargeAmount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthMemberYUERechargeAmount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">退款金额</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayReturnOrderAmount}}</span>
						<el-tooltip v-if="state1" effect="dark" placement="top-start">
							<div slot="content" style="line-height: 20px;">
								当日现金：{{datas.shopLog.dayReturnCurrentMonthCash}}<br>
								当日余额：{{datas.shopLog.dayReturnCurrentMonthYue}}<br>
								当日充值：{{datas.shopLog.dayReturnCurrentMonthRecharge}}<br>
								往日现金：{{datas.shopLog.dayReturnLastMonthCash}}<br>
								往日余额：{{datas.shopLog.dayReturnLastMonthYue}}<br>
								往日充值：{{datas.shopLog.dayReturnLastMonthRecharge}}<br>
							</div>
							<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
						</el-tooltip>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthReturnOrderAmount}}</span>
						<el-tooltip v-if="state1" effect="dark" placement="top-start">
							<div slot="content" style="line-height: 20px;">
								当月现金：{{datas.shopLog.monthReturnCurrentMonthCash}}<br>
								当月余额：{{datas.shopLog.monthReturnCurrentMonthYue}}<br>
								当月充值：{{datas.shopLog.monthReturnCurrentMonthRecharge}}<br>
								往月现金：{{datas.shopLog.monthReturnLastMonthCash}}<br>
								往月余额：{{datas.shopLog.monthReturnLastMonthYue}}<br>
								往月充值：{{datas.shopLog.monthReturnLastMonthRecharge}}<br>
							</div>
							<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
						</el-tooltip>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">门店流水</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayShopRunningAmount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.mouthShopRunningAmount.toFixed(2)}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">宠物洗护卡(金额/张)</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0张</span>
						<span v-else>{{datas.shopLog.dayWashBeautyCard_BuyAmount}}/{{datas.shopLog.dayWashBeautyCard_BuyCount}}张</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0张</span>
						<span v-else>{{datas.shopLog.monthWashBeautyCard_BuyAmount}}/{{datas.shopLog.monthWashBeautyCard_BuyCount}}张</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">美容单数</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayBeautyOrderCount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthBeautyOrderCount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">洗澡单数</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayWashOrderCount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthWashOrderCount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">单项服务数</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.daySingleServiceCount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthSingleServiceCount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">美容/洗澡单数合计</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.dayWashBeautyOrderCount}}</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0</span>
						<span v-else>{{datas.shopLog.monthWashBeautyOrderCount}}</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">活体销售(金额/数量)</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0只</span>
						<span v-else>
							{{$public.jia(datas.shopLog.dayCat_SaleAmount,datas.shopLog.dayDog_SaleAmount)}}
							/
							{{$public.jia(datas.shopLog.dayCat_SaleCount,datas.shopLog.dayDog_SaleCount)}}只
						</span>
						<el-tooltip v-if="state1" effect="dark" placement="top-start">
							<div slot="content" style="line-height: 20px;">
								猫：{{datas.shopLog.dayCat_SaleAmount}}/{{datas.shopLog.dayCat_SaleCount}}只<br>
								狗：{{datas.shopLog.dayDog_SaleAmount}}/{{datas.shopLog.dayDog_SaleCount}}只<br>
							</div>
							<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
						</el-tooltip>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0只</span>
						<span v-else>
							{{$public.jia(datas.shopLog.monthCat_SaleAmount,datas.shopLog.monthDog_SaleAmount)}}
							/
							{{$public.jia(datas.shopLog.monthCat_SaleCount,datas.shopLog.monthDog_SaleCount)}}只
						</span>
						<el-tooltip v-if="state1" effect="dark" placement="top-start">
							<div slot="content" style="line-height: 20px;">
								猫：{{datas.shopLog.monthCat_SaleAmount}}/{{datas.shopLog.monthCat_SaleCount}}只<br>
								狗：{{datas.shopLog.monthDog_SaleAmount}}/{{datas.shopLog.monthDog_SaleCount}}只<br>
							</div>
							<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
						</el-tooltip>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">活体订金(金额/数量)</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0单</span>
						<span v-else>
							{{datas.shopLog.dayLivingDeposit_OrderAmount}}
							/
							{{datas.shopLog.dayLivingDeposit_OrderCount}}单
						</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0</span>
						<span v-else>
							{{datas.shopLog.monthLivingDeposit_OrderAmount}}
							/
							{{datas.shopLog.monthLivingDeposit_OrderCount}}单
						</span>
					</div>
				</div>
				<div class="panel2TableCell">
					<div class="panel2TableCellItem">已用活体订金(金额/数量)</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0</span>
						<span v-else>
							{{datas.shopLog.dayLivingDeposit_UseAmount}}
							/
							{{datas.shopLog.dayLivingDeposit_UseOrder}}单
						</span>
					</div>
					<div class="panel2TableCellItem">
						<span v-if="!state1">0/0</span>
						<span v-else>
							{{datas.shopLog.monthLivingDeposit_UseAmount}}
							/
							{{datas.shopLog.monthLivingDeposit_UseOrder}}单
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="panel3">
			<div class="panel31">
				<div class="panel31Tit">
					总销售金额
				</div>
				<div id="myChartShop0" style="height: 350px;margin-top:12px;"></div>
				<div style="position: absolute;width:140px;height: 140px;border-radius: 50%;background-color: #fff;top:159px;left:100px;text-align: center;font-size: 20px;line-height: 40px;">
					<div style="padding-top:30px;font-size: 20px;color:#333;font-weight: bold;">{{$public.jia(myChart0TotalCash,myChart0TotalWiped)}}</div>
					<div style="padding-top:0px;color:#666;font-size: 14px;">
						总金额
						<el-tooltip v-if="state1" effect="dark" placement="top-start">
							<div slot="content" style="line-height: 20px;">
								现金：{{myChart0TotalCash}} ({{$public.chu(myChart0TotalCash*100,($public.jia(myChart0TotalCash,myChart0TotalWiped)))}}%)<br>
								核销：{{myChart0TotalWiped}} ({{$public.chu(myChart0TotalWiped*100,$public.jia(myChart0TotalCash,myChart0TotalWiped))}}%)<br>
							</div>
							<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:0px;vertical-align: middle;"/>
						</el-tooltip>
					</div>
				</div>
			</div>
			<div class="panel32">
				<div class="panel32Tit">
					流水折线图
				</div>
				<div id="myChartShop1" style="height: 350px;margin-top:12px;"></div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import echarts from "echarts";
	export default {
		data() {
			return {
				currDate: '',
				params: {
					dateType: 'date',
					shopId: this.$store.getters.curShopInfo.shop_id,
					currDate: '',
				},
				
				state1:false,
				datas:{shopLog:{},orderTypeAmount:[],runningAmountMap:{},},
				myChart0:null,
				myChart0TotalCash:0,
				myChart0TotalWiped:0,
				myChart1:null,
			}
		},
		computed:{
			shopId(){
				return this.$store.state.shopId;
			}
		},
		created() {
			this.shopList = [{ shop_id: "5e9412e0b2bfbc089daerr10", shop_name: "驯养中心" },
  { shop_id: "5e9412e0b2bfbc089daerr11", shop_name: "小程序店" },
  { shop_id: "5e9412e0b2bfbc089daerr12", shop_name: "金水区店" },
  { shop_id: "5e9412e0b2bfbc089daerr14", shop_name: "指挥中心" },
  { shop_id: "5e9412e0b2bfbc089daerr17", shop_name: "线上旗舰店" },
  { shop_id: "5e9412e0b2bfbc089daerr18", shop_name: "郑东新区店" },
{shop_id:"5e9412e0b2bfbc089daerr15",shop_name: "东区店" },
{shop_id:"5e9412e0b2bfbc089daerr13",shop_name: "陇海店" },
{shop_id:"5e9412e0b2bfbc089daerr16",shop_name: "二七店" }]
			this.currDate = new Date();
			this.params.currDate = this.$public.FTimeStr10(new Date());
			this.clickSearch();
		},
		mounted() {
			this.myChart0 = echarts.init(document.getElementById("myChartShop0"));
			this.myChart1 = echarts.init(document.getElementById("myChartShop1"));
		},
		methods: {			
			downloadStaffPaiMing(){
				let loading = this.$loading();
				axios.get(process.env.VUE_APP_Url5+'api/ShopPerformancePKService/GetStaffDayListExcel', {
					params:{
					day:this.$public.FTime(this.$public.FTimeStr10(this.currDate),'YYYY-MM-DD')
					},
					responseType: 'blob'
				}).then(response => {
					var href = window.URL.createObjectURL(response.data); //创建下载的链接
					var downloadElement = document.createElement('a');
					downloadElement.href = href;
					downloadElement.download = '当日员工业绩导出.xlsx';
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放掉blob对象
					loading.close();
				}).catch(err => {
					console.log(err)
				})
			},
			changeShop(){
				this.clickSearch()
			},
			changePicker(val) {
				this.params.currDate = this.$public.FTimeStr10(val);
				this.clickSearch()
			},
			changeDateType(){
				this.clickSearch()
			},
			clickSearch() {
				this.getDatas();
			},
			getDatas(){
				this.state1 = false;
				let params = {
					time:this.params.currDate, // 查看的时间;时间戳
					way:this.params.dateType,  // date:本日 week:本周 month:本月 
					shopId:this.params.shopId,  
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/shop/sum/data', params).then(res => {
					loading.close()
					this.datas = res.data;
					this.$nextTick(()=>{
						this.state1 = true;
						this.draw0()
						this.draw1()
					})
				})
			},
			draw0(){
				this.myChart0TotalCash = 0
				this.myChart0TotalWiped = 0
				let arr = this.datas.orderTypeAmount;
				let d = []
				for(let i=0;i<arr.length;i++){
					d.push({value:arr[i].orderTotalAmount, name:arr[i].typeName})
					this.myChart0TotalCash = this.$public.jia(this.myChart0TotalCash,arr[i].orderAmount_Cash)
					this.myChart0TotalWiped = this.$public.jia(this.myChart0TotalWiped,arr[i].orderAmount_Wiped)
				}
				this.myChart0.setOption({
					color:['#F5882A','#58A2F7','#FBCB63','#F76260','#8167F5','#F5EC67','#28D3DB','#96D9FF'],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: '30',
						top: 'middle',
						textStyle:{
							fontSize:'14',
							color: '#666',
							lineHeight:'30'
						},
						formatter:(e)=>{
							for(let i=0;i<arr.length;i++){
								if(arr[i].typeName===e){
									return e+'：'+arr[i].orderTotalAmount
									+ ' ( 现金'+this.$public.chu(arr[i].orderAmount_Cash*100,arr[i].orderTotalAmount)+'%'
									+ '；核销'+this.$public.chu(arr[i].orderAmount_Wiped*100,arr[i].orderTotalAmount)+'%)'
								}
							}
						},
					},
					series: [
						{
							name: '访问来源',
							type: 'pie',
							radius: ['40%','75%'],
							center: [150,180],
							label: {
								position: 'inner',
								fontSize: 14,
								formatter:(val)=>{
									return val.percent+'%';
								}
							},
							data: d,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							tooltip:{
								formatter:(val)=>{
									return "<div>"+
										val.name+":"+val.value+"("+val.percent+"%)"+
										"<div style='padding-left:20px;'>"+
											"现金:"+arr.filter((item)=>{if(item.typeName===val.name){return item}})[0].orderAmount_Cash+
										"</div>"+
										"<div style='padding-left:20px;'>"+
											"核销:"+arr.filter((item)=>{if(item.typeName===val.name){return item}})[0].orderAmount_Wiped+
										"</div>"+
									"</div>"
									// return val.name
								}
							}
						},
					]
				})
			},
			draw1(){
				let x = this.datas.runningAmountMap.x
				let series = []
				for(let i=0;i<this.datas.runningAmountMap.datas.length;i++){
					let item = this.datas.runningAmountMap.datas[i]
					item.type = "line"
					item.data = item.values
					series.push(item)
				}
				this.myChart1.setOption({
					color:['#F76260','#96D9FF','#FBCB63','#8167F5','#28D3DB','#F5EC67','#F5882A','#58A2F7'],
					legend: { left: 'right' },
					tooltip: {
						trigger: 'axis',
						// showContent: false
					},
					yAxis: {
						gridIndex: 0,
						type: 'value',
						name: '单位：元',
					},
					grid: { top: '15%' },
					xAxis: {
						type: 'category',
						name: '时间',
						splitLine: { show: false },
						data: x,
					},
					series: series,
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.page {
		width:100%;
		.nucleustit {
			display: flex;justify-content: space-between;height: 57px;box-sizing: border-box;padding:16px 16px 0 16px;background-color: #fff;
			.tit {
				color: $fontColor;font-size: 18px;font-weight: bold;margin:4px 0;padding:0 6px;box-sizing: border-box;height: 20px;line-height: 20px;
			}
		}
		.panel1{
			width:100%;padding:14px;border-radius: 10px;background-color: #fff;display: flex;margin-top:12px;box-sizing: border-box;flex-wrap: wrap;
			.panel1Item{
				text-align: center;width:16.6%;border-right: 1px solid #ededed;height: 70px;
				.num1{
					font-size: 16px;color:$fontColor;font-weight: bold;padding-top:15px;
				}
				.text1{
					font-size: 12px;color:#666;padding-top:12px;
				}
			}
		}
		.panel2{
			width:calc(100% - 766px);padding:20px;border-radius: 10px;background-color: #fff;margin-top:12px;box-sizing: border-box;margin-right: 13px;display: inline-block;
			.panel2Tit{
				font-size: 18px;color:$fontColor;margin-bottom:10px;
			}
			.panel2Item{
				width:calc(50% - 6px);border: 1px solid #eaedf7;height: 80px;border-radius: 10px;box-sizing: border-box;display: flex;margin-top:12px;
				.panel2ItemL{
					width:45px;height: 45px;margin:18px 22px 22px 18px;
				}
				.panel2ItemR{
					margin-top:22px;
					.num2{
						font-size: 16px;color:#242F57;
					}
					.text2{
						font-size: 12px;color:#636E95;padding-top:12px;
					}
				}
			}
			.panel2Table{
				width:100%;height: 660px;margin-top: 12px;
				.panel2TableTit{
					display: flex;background-color: #F3F5FA;border-radius: 10px 10px 0 0;
					.panel2TableTitItem{
						font-size: 16px;color:$fontColor;width:100%;text-align: center;line-height: 50px;
					}
				}
				.panel2TableCell{
					display: flex;
					.panel2TableCellItem{
						font-size: 14px;color:#666;width:100%;text-align: center;line-height: 50px;border-bottom: 1px solid #f2f2f2;border-right: 1px solid #f2f2f2;
						&:first-child{
							border-left: 1px solid #f2f2f2;
						}
					}
				}
			}
		}
		.panel3{
			width:753px;display: inline-block;vertical-align: top;margin-top:12px;margin-bottom:20px;
			.panel31{
				height: 420px;border-radius: 10px;background-color: #fff;padding:20px;box-sizing: border-box;position: relative;
				.panel31Tit{
					font-size: 18px;color:$fontColor;
				}
			}
			.panel32{
				height: 490px;border-radius: 10px;background-color: #fff;padding:20px;box-sizing: border-box;margin-top:12px;position: relative;
				.panel31Tit{
					font-size: 18px;color:$fontColor;
				}
			}
		}
	}
</style>
